import { createFileRoute } from '@tanstack/react-router'
import Page from '@/components/pages/inventory/settings/address/jp/page'

export const Route = createFileRoute('/_app/backend-settings/address/jp')({
  component: Page,
})
